<template>
  <!-- 5-6 医疗机构信息认证信息修改提示 审核中 -->
  <div class="main-box">
    <!--    标题-->
    <div class="title-css">
      {{ $t("institutionalInformation") }}
    </div>
    <!-- 弹窗的操作部分 -->
    <div class="im-box">
      <div class="div-1">
        <div class="row">
          <img src="./assets/Vector.svg" alt="" />
        </div>
      </div>

      <!--          内容-->
      <div class=" div-2">
        <div class="div-2-main">
          <p>{{ $t("reviewingInstitutionalRegistration") }}</p>
        </div>
      </div>

      <!--          按钮-->
      <div class=" div-3">
        <a href="#" class="button" @click="returns()">{{ $t("close") }}</a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Institutional",
  components: {},
  data() {
    return {};
  },
  created() {},
  computed: {},
  methods: {
    returns() {
      this.$router.push("/login");
    }
  }
};
</script>
<style scoped>
.pages-css {
  width: 100%;
  height: 100%;
  padding: 0 20px;
  box-sizing: border-box;
}

.main-box {
  width: 100%;
  height: 100%;
}

.title-css {
  font-family: "lucida sans unicode", "lucida grande", sans-serif; /*字体*/
  color: #6b5656; /*字体颜色*/
  font-size: 2em; /*字体大小*/
  text-align: center; /*对齐方式*/
  line-height: 4; /*行间距*/
  margin-top: 20px;
}

.im-box {
  width: 498px;
  height: 266px;
  background: #ffffff;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 4px;
  margin: auto;
}

.div-1 {
  width: 100%;
  height: 90px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 80px;
}

.row {
  width: 50px;
  height: 50px;
  text-align: center;
  /* 第二主色 */
  background: #51abff;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: courier, "courier new", monospace; /*字体*/
  color: #ffffff; /*字体颜色*/
  font-size: 55px; /*字体大小*/
  margin-top: 40px;
}

.div-2 {
  width: 100%;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
}

.div-2-main {
  width: 280px;
  height: 48px;
  /* 表头样式 */
  font-family: "Open Sans";
  text-align: center; /*对齐方式*/
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  /* 灰色字体 */
  color: #686868;
}

.div-3 {
  width: 100%;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.button {
  color: #51abff;
  padding: 0px 19px;
  border: 1px solid #51abff;
  order: 0;
  flex-grow: 0;
  margin: 0px 10px;
  font-family: "Open Sans";
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  border-radius: 5px;
}
</style>



// WEBPACK FOOTER //
// src/pages/popupWindows/underReview.vue